/*
 * @Author: Chao Yang
 * @Date: 2020-01-22 11:02:11
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 14:55:29
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Account from 'src/app/domain/model/account';
import { BaseProxy } from '../base.proxy';
import { IInvestmentDetailLayout2023 } from '../../model/dashboard';

@Injectable()
export class LayoutProxy extends BaseProxy {
  getAccountDetailConfiguration(
    fundId: number,
    crmAccountId?: number,
    viewDataForAllInvestors?: boolean
  ): Observable<Account.IConfiguration> {
    return this._http.get<Account.IConfiguration>(
      '/ip/api/layout/fund/' +
        fundId +
        '/crmAccount/' +
        crmAccountId +
        `?viewDataForAllInvestors=${viewDataForAllInvestors}`
    );
  }

  getAccountDetailLayout2023(
    fundId: number,
    crmAccountId?: number,
    viewDataForAllInvestors?: boolean
  ): Observable<IInvestmentDetailLayout2023> {
    return this._http.get<IInvestmentDetailLayout2023>(
      '/ip/api/layout/fund/' +
        fundId +
        '/crmAccount/' +
        crmAccountId +
        `/2023?viewDataForAllInvestors=${viewDataForAllInvestors}`
    );
  }

  updateAccountDetailLayout2023(updateDto: {
    fundId: number[];
    layout: string;
  }) {
    return this._http.put('/ip/api/layout/investment/detail', updateDto);
  }
}
